"use strict";

exports.__esModule = true;
exports.MetricValueAggregateThumbnail = MetricValueAggregateThumbnail;
var _react = _interopRequireDefault(require("react"));
var _Metrics = require("../../../Catalogs/Metrics");
var _Measures = require("../../Measures");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for MetricValueWidget.
 */
function MetricValueAggregateThumbnail(_ref) {
  var metricName = _ref.metricName,
    hideLabel = _ref.hideLabel,
    _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height;
  var metric = (0, _Metrics.getMetricDefinition)(metricName);
  var value = Math.random() * 100;
  return /*#__PURE__*/_react["default"].createElement(_Measures.MeasurementValue, {
    x: x,
    y: y,
    width: width,
    height: height,
    value: value,
    units: metric.units,
    label: !hideLabel && (metric.label || metric.name)
  });
}